import Echo from "laravel-echo";

import Pusher from "pusher-js";

try {
    window.Pusher = Pusher;
    window.Echo = new Echo({
        broadcaster: 'reverb',
        key: process.env.MIX_REVERB_APP_KEY,
        wsHost: process.env.MIX_REVERB_HOST,
        wsPort: process.env.MIX_REVERB_PORT ?? 80,
        wssPort: process.env.MIX_REVERB_PORT ?? 443,
        forceTLS: (process.env.MIX_REVERB_SCHEME ?? 'https') === 'https',
        enabledTransports: ['ws', 'wss'],
        // broadcaster: "pusher",
        // key: `${process.env.MIX_PUSHER_APP_KEY}`,
        // cluster: `${process.env.MIX_PUSHER_APP_CLUSTER}`,
        // forceTLS: false,
    });
console.log({
    key: process.env.MIX_REVERB_APP_KEY,
    wsHost: process.env.MIX_REVERB_HOST,
    wsPort: process.env.MIX_REVERB_PORT ?? 80,
    wssPort: process.env.MIX_REVERB_PORT ?? 443,
    forceTLS: (process.env.MIX_REVERB_SCHEME ?? "https") === "https",
});
    window.Echo.private(`App.Models.Customer.${window.userId}`).notification(
        (notification) => {
            console.log(notification.message);
            // Update your frontend to display the notification
        }
    );
   
} catch (error) {
    console.error(error);
    console.log({
        key: process.env.MIX_REVERB_APP_KEY,
        wsHost: process.env.MIX_REVERB_HOST,
        wsPort: process.env.MIX_REVERB_PORT ?? 80,
        wssPort: process.env.MIX_REVERB_PORT ?? 443,
        forceTLS: (process.env.MIX_REVERB_SCHEME ?? "https") === "https",
    });
}
